import { useAuth0 } from "@auth0/auth0-react";
import { Autocomplete, TextField } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { globalConfig } from "../../../../Common/configuration/config";
import useAssotiation from "../../../hooks/useAssociationFlow";
import { AssociateCommand } from "../../../commands/association";
import FormHeader from "../../../../Common/components/templates/formHeader";
import PrimaryButton from "../../../../Common/components/templates/buttons/primary";
import { useIntl } from 'react-intl';
import FormDirections from "../../../../Common/components/templates/formDirections";
import SecondaryButton from "../../../../Common/components/templates/buttons/secondary";


export const Association = (props: any) => {
    let params = new URLSearchParams(props.location.search);
    let redirect_uri = params.get("redirect_uri");
    let auth0state = params.get("state");
    if (redirect_uri !== null)
        localStorage.setItem("redirect_uri", redirect_uri as string);
    if (auth0state !== null)
        localStorage.setItem("auth0state", auth0state as string);
    const config = globalConfig.get();
    const intl = useIntl();
    const trustTranslation = intl?.messages["organisation"] || "organisation";
    const {
        isLoading,
        isAuthenticated,
        getAccessTokenSilently,
        loginWithRedirect
    } = useAuth0();

    const [loading, setLoading] = React.useState(false);

    const { association, getCustomers, handleReturnCustomersShortNameAndCode, handleAssociation } = useAssotiation();

    const [hrUsername, setHrUsername] = useState("");
    const [hrPassword, setHrPassword] = useState("");
    const [customerCode, setCustomerCode] = useState("");

    const redirectToAction = (auth0state: string, domain: string, isCanceled: boolean = false) => {
        const temp: any = window;
        console.log("i am inside the function for redirecting")
        temp.location = `https://${domain}/continue?state=${encodeURIComponent(auth0state)}${isCanceled ? "&cancel=true" : ""}`;
    };

    const startAssociationMethod: any = useCallback(
        async (hrUsername: string, hrPassword: string, customerCode: string) => {
            var accessToken = await getAccessTokenSilently({
                ignoreCache: true,
                scopesToInclude: globalConfig.config.Scope || ""
            });
            handleAssociation(accessToken,
                new AssociateCommand({ healthRosterUsername: hrUsername, healthRosterPassword: hrPassword, customerCode: customerCode })
            )
        },
        [handleAssociation]
    );

    const actionState = auth0state || localStorage.getItem("auth0state");

    useEffect(() => {
        if (isAuthenticated && !isLoading) {
            (async function GetCustomersShortNameAndCode() {
                var accessToken = await getAccessTokenSilently();
                await handleReturnCustomersShortNameAndCode(accessToken);
            })();
        }
    }, [isAuthenticated, isLoading]);

    useEffect(() => {
        setLoading(false);
        if (association.result.isValid && actionState) {
            console.log("redirecting back to action");
            redirectToAction(actionState, config.Domain, false);
        }
    }, [association.result.isValid, actionState, config.Domain]);

    useEffect(() => {
        if (!isAuthenticated && !isLoading) {
            loginWithRedirect({ redirectUri: `${config.Host}association?redirect_uri=${localStorage.getItem("redirect_uri")}` });
        }
    }, [isAuthenticated, isLoading]);

    const handleSubmit = (event: any) => {
        console.log(params);
        setLoading(true);
        startAssociationMethod(hrUsername, hrPassword, customerCode);
        event.preventDefault();
    };

    return (
        <form className="form" onSubmit={handleSubmit}>
            <FormHeader title="Associate your account" />

            <FormDirections>
                Your account is not associated with any {trustTranslation.toString()} yet, please provide your Optima credentials to associate your {trustTranslation.toString()}
            </FormDirections>

            {association.result.message && association.result.isValid !== true && !loading ? (
                <div className="error">
                    {" "}
                    {association.result.message} {" "}
                </div>
            ) : null}
            {association.result.message === "Email must be verified" ? (
                <div className="error">
                    {" "}
                    Please verify your email and refresh the page afterwards.
                </div>
            ) : null}
            {association.result.isValid === true && !loading ? (
                <div className="success">
                    Your account has been successfully associated!
                </div>
            ) : null}

            <div className="content">
                <label htmlFor="auto-complete" className="label">
                    {trustTranslation.toString()}
                </label>
                <Autocomplete
                    id="auto-complete"
                    autoComplete
                    includeInputInList
                    options={getCustomers.result}
                    renderOption={(props, option) => (
                        <li {...props} style={{ fontSize: "13px" }}>
                            {option.shortName}
                        </li>
                    )}
                    onChange={(event: any, value: any) => {
                        if (value !== null) setCustomerCode(value.code)
                    }}
                    getOptionLabel={(option: any) => option.shortName}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            required
                            style={{ width: "100%" }}
                        />
                    )}
                />

                <label htmlFor="username" className="label">
                    Optima username
                </label>
                <TextField
                    id="username"
                    variant="outlined"
                    value={hrUsername}
                    onChange={event => setHrUsername(event.target.value)}
                    required
                    style={{ width: "100%" }}
                />

                <label htmlFor="password" className="label">
                    Optima password
                </label>
                <TextField
                    id="password"
                    variant="outlined"
                    value={hrPassword}
                    onChange={event => setHrPassword(event.target.value)}
                    required
                    type="password"
                    style={{ width: "100%" }}
                />

                <div className="buttons">
                    <PrimaryButton
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={loading}
                    >
                        Associate
                    </PrimaryButton>
                    <SecondaryButton
                        onClick={() => actionState && redirectToAction(actionState, config.Domain, true)}
                        disabled={!actionState}
                    >
                        Skip
                    </SecondaryButton>
                </div>

                <FormDirections>
                    Association is connecting account to {trustTranslation.toString()}
                </FormDirections>
            </div>
        </form>
    );
};